<template>
  <div>
<!--    <b-card class="text-left" header="Уведомление">-->
<!--        <b-card-text>-->
<!--          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed justo mauris, aliquam sit amet molestie non, tristique ac arcu. In pretium id dolor ac condimentum. Vivamus auctor lorem ac porttitor facilisis. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Mauris suscipit suscipit laoreet. Suspendisse a venenatis turpis. Duis sit amet sem ut libero pellentesque dignissim. Morbi congue mi eget fringilla aliquam. Sed rhoncus enim consectetur urna mattis, sit amet placerat nulla dictum. Cras rhoncus tellus vel laoreet convallis.-->
<!--        </b-card-text>-->
<!--&lt;!&ndash;      <ul>&ndash;&gt;-->
<!--&lt;!&ndash;        <li v-for="(account) in $store.state.accounts" :key="account.account_id">&ndash;&gt;-->
<!--&lt;!&ndash;          {{account.account_id}}&ndash;&gt;-->
<!--&lt;!&ndash;          <ul v-for="(app) in account.apps" :key="app.app_id">&ndash;&gt;-->
<!--&lt;!&ndash;            <li>{{app.app_id}}</li>&ndash;&gt;-->
<!--&lt;!&ndash;          </ul>&ndash;&gt;-->
<!--&lt;!&ndash;        </li>&ndash;&gt;-->
<!--&lt;!&ndash;      </ul>&ndash;&gt;-->
<!--    </b-card>-->
<!--    {{account_list}}-->
<!--    {{accounts}}-->
    <div v-if="account_list_len !== 0" class="accordion" role="tablist">

      <b-card no-body class="mb-1">
        <div v-for="(account) in accounts" :key="account.account_id">
          <b-card-header header-tag="header" class="p-1 text-left" role="tab">
            <b-row block v-b-toggle="'accordion-account-'+account.account_id">
                <b-col><p class="ml-3" variant="info">ЛС: {{account.account_id}} [{{account.contract}}] {{account.address_text}}</p></b-col>
                <b-col class="balance-col">Баланс: {{account.current_balance}} тг</b-col>
                <b-col class="balance-col">
                  <b-button size="sm" variant="outline-primary" class="me-2" @click.stop.prevent="showAccountReceipt(account.account_id)"><b-icon-receipt-cutoff aria-hidden="false"></b-icon-receipt-cutoff></b-button>
                  <b-button size="sm" variant="outline-primary"><b-icon-arrow-repeat aria-hidden="false" @click.stop="refreshAccount(account.account_id)"></b-icon-arrow-repeat></b-button>
                </b-col>
            </b-row>
          </b-card-header>
          <b-collapse :id="'accordion-account-'+account.account_id" accordion="account-accordion" role="tabpanel">
            <b-card-body>
              <b-card v-for="(app, index) in account.apps" :key="index" no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1 text-left" role="tab">
                  <b-row block v-b-toggle="'accordion-app-'+app.app_id">
                    <b-col l>
                      <p class="ml-3" variant="info">{{ app.tar_plan_name }}
                        <span v-if="app.app_code !== null">[{{ app.app_code }}]</span>
                        <b-icon v-for="service_type in app.service_types" :key="service_type" v-b-tooltip="service_type" class="icon-service-type" :icon="serviceTypeIcon(service_type)" :variant="serviceTypeIconColor(app)"/>
                        <span v-if="app.inet_speed != ''"> {{localiceSpeed(app.inet_speed)}}</span>
                      </p>
                    </b-col>
                    <b-col>{{ app_charge(app) }} тг/мес</b-col>
                    <b-col class="actions-col">
                      <b-button v-if="app.service_types.includes('INTERNET')" size="sm" variant="outline-success"><b-icon-three-dots aria-hidden="false" @click.stop="showPassChange(app, $event)"></b-icon-three-dots></b-button>
                    </b-col>
                    <b-col class="actions-col">
                      <b-button v-if="app.service_types.includes('PHONE')" size="sm" variant="outline-success"><b-icon-telephone-fill aria-hidden="false" @click.stop="showPhoneTraffic(app, $event)"></b-icon-telephone-fill></b-button>
                      <b-button v-if="app.service_types.includes('INTERNET')" size="sm" variant="outline-success"><b-icon-globe aria-hidden="false" @click.stop="showInetTraffic(app, $event)"></b-icon-globe></b-button>
                    </b-col>
                    <b-col class="actions-col">
                      <b-button v-if="app.blockable && !app.blocked" size="sm" variant="outline-warning"><b-icon icon="pause-fill" aria-hidden="true" @click.stop="showBlock(app, $event)"></b-icon></b-button>
                      <b-button v-if="app.blockable && app.blocked" size="sm" variant="outline-success"><b-icon icon="play-fill" aria-hidden="true" @click.stop="showUnblock(app)"></b-icon></b-button>
                    </b-col>
                    <b-col class="actions-col"><b-button v-if="app.plan_change" size="sm" variant="outline-primary" @click.stop="showPlanChange(app, $event)"><b-icon icon="shift-fill" aria-hidden="true"></b-icon></b-button></b-col>
                  </b-row>
                </b-card-header>

                <b-collapse v-if="app_charge(app) > 0" :id="'accordion-app-'+app.app_id" accordion="app-accordion" role="tabpanel">
                  <b-card-body>
                    <b-container>
                      <b-row v-for="(service, index) in app.services" :key="index">
                        <b-col>{{ service.service_name }}</b-col>
                        <b-col>{{ service.charge }} тенге</b-col>
                      </b-row>
                    </b-container>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </b-card-body>
          </b-collapse>
        </div>
      </b-card>
    </div>
    <div v-else>
      Лицевые счета не найдены. Если У Вас уже есть Пин то вы можете <a class="link-primary" @click.prevent="showAddAccount">привязать</a> лицевой счет к Вашей учетной записи.
    </div>

  <b-modal hide-footer id="app-block" title="Блокировать услугу?">
    <b-table striped hover :items="$store.state.app_block_tarif_list" :fields="charge_fields"></b-table>
    <b-button variant="danger" @click="appBlockConfirm">Блокировать</b-button>
    <b-button variant="success" @click="hideBlock">Назад</b-button>
  </b-modal>

  <b-modal hide-footer id="app-unblock" title="Разблокировать услугу?">
    <b-button variant="danger" @click="appUnBlockConfirm">Разблокировать</b-button>
    <b-button variant="success" @click="hideUnBlock">Назад</b-button>
  </b-modal>

  <b-modal hide-footer id="app-change-plan" title="Сменить тарифный план" no-close-on-backdrop no-close-on-esc hide-header-close>
    <div v-if="confirm_switch">
      <b-card :header="switch_to_plan.name">
        <b-card-text>
          Скорость: {{switch_to_plan.inet_speed}}
          Стоимость: {{switch_to_plan.charge}} тг/мес
        </b-card-text>
        <b-button variant="success" @click="changePlan">Подтвердить</b-button>
        <b-button variant="danger" @click="closeConfirm">Назад</b-button>
      </b-card>
    </div>
    <div v-else>
      <b-card-group>
        <b-card v-for="tar_plan in $store.state.tar_plan_change_list" :key="tar_plan.tar_plan_id" :header="tar_plan.name">
          <b-card-text>
            Скорость: {{tar_plan.inet_speed}}
            Стоимость: {{tar_plan.charge}} тг/мес
          </b-card-text>
          <b-button v-if="tar_plan.current" disabled variant="primary">Текущий</b-button>
          <b-button v-else variant="success" @click.prevent="switchConfirm(tar_plan)">Подключить</b-button>
        </b-card>
      </b-card-group>
      <b-button class="m-1" variant="primary" @click="closePlanChange">Назад</b-button>
    </div>
  </b-modal>

  <b-modal hide-footer id="app-inet-traffic" title="Интернет траффик" size="lg">
    <b-table striped hover :items="$store.state.internet_traffic" :fields="inet_fields" :tbody-tr-class="traficRowClass"></b-table>
    <b-button variant="success" @click="hideInetTraffic">Назад</b-button>
  </b-modal>
    
  <b-modal hide-footer id="app-phone-traffic" title="Телефонный траффик" size="lg">
    <b-table striped hover :items="$store.state.phone_calls" :fields="call_fields" show-empty>
      <template #empty="">
        <h4>Нет записей</h4>
      </template>
    </b-table>
    <b-button variant="success" @click="hidePhoneTraffic">Назад</b-button>
  </b-modal>

  <b-modal hide-footer id="add-account" title="Добавить новый ЛС">
    <form @submit.prevent>
        <b-input type="text" name="pin" v-model="form.pin" placeholder="Пин"/>
        <b-input type="text" name="account_id" v-model="form.account_id" placeholder="Лицевой счет"/>
        <b-button variant="success" @click="addAccount">Добавить</b-button>
        <b-button variant="primary" @click="hideAddAccount">Назад</b-button>
    </form>
  </b-modal>

  <b-modal hide-footer id="app-pass-change" title="Сменить пароль доступа к интернету?">
    <b-input id="new_password_input" type="text" name="new_pass" :state="!valid_pass" v-model="new_password" placeholder="Новый пароль"/>
    <b-form-text id="new_password_input">
      Внимание. При смене пароля требуется установить новый пароль на модеме(роутере). Данное действие не меняет пароль Wi-Fi.
    </b-form-text>
    <b-form-invalid-feedback :state="!valid_pass">
      Не мение 6 символов.
    </b-form-invalid-feedback>
    <div class="mt-1">
      <b-button variant="danger" :disabled="valid_pass" @click="appChangePass">Изменить</b-button>
      <b-button variant="success" @click="hidePassChange">Назад</b-button>
    </div>
  </b-modal>

  <b-modal hide-footer id="account-receipt" title="Актуальный счет">
    <b-form v-if="current_account">
      <b-form-checkbox name="send_to_email" v-model="receipt_to_email" switch @change="setSendToEmail"><div class="ps-2">Квитанции на email</div></b-form-checkbox>
      <b-input-group class="mt-3 p-1" v-if="receipt_to_email">
        <b-form-input v-model="account_email" :disabled="!change_email_enabled" type="text" name="account_email"/>
        <b-input-group-append>
          <b-button v-if="!change_email_enabled" variant="primary" @click.prevent="emailChange(true)">Изменить</b-button>
          <b-button v-if="change_email_enabled" variant="success" @click.prevent="emailChange(false)">Отменить</b-button>
          <b-button v-if="change_email_enabled" variant="primary" @click.prevent="changeAccountEmail">Сохранить</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form>
    <hr/>
    <div v-if="$store.state.current_document">
      <div>К оплате: {{$store.state.current_document_content.to_pay}}</div>
      <div>Начисленно: {{$store.state.current_document_content.charge}}, Долг: {{$store.state.current_document_content.balance_out - $store.state.current_document_content.charge}}, Оплаты: {{$store.state.current_document_content.payments}}</div>
      <b-table-lite :items="$store.state.current_document_items" :fields="receipt_fields"></b-table-lite>
    </div>
<!--    <b-input type="text" name="account_email" :state="!valid_pass" v-model="custom_email"/>-->
<!--    <b-form-invalid-feedback :state="!valid_pass">-->
<!--        Не мение 6 символов.-->
<!--      </b-form-invalid-feedback>-->
    <div class="mt-1">
      <b-button variant="success" @click="hideAccountReceipt">Назад</b-button>
      <b-button class="ms-2" variant="primary" @click.stop.prevent="openInNewTab"><b-icon-printer class="me-2"></b-icon-printer>Печать</b-button>
    </div>
  </b-modal>

  </div>
</template>

<script>
// import Vue from "vue";
import { mapGetters } from 'vuex'
import Vue from "vue";
export default {
  name: "ProfileView",
  data() {
    return {
      form: {
        pin: "",
        account_id: "",
      },
      current_account: null,
      is_custom_email: false,
      custom_email: '',
      confirm_switch: false,
      switch_to_plan: null,
      selected_app: null,
      new_password: '',
      change_email_enabled: false,
      charge_fields: [{key: 'value', label: 'Цена'},{key: 'service_name', label: 'Позиция'}],
      tar_plan_change_fields: [{key: 'name', label: 'План'}, {key: 'charge', label: 'Стоимость'}, {key: 'action', label:''}],
      inet_fields: [
        {key: 'framed_ip', label: 'IP'}, {key: 'inbound', label: 'Входящий'}, {key: 'outbound', label:'Исходящий'},
        {key: 'speed', label:'Скорость'},
        {key: 'since', label:'Начало'},{key: 'until', label:'Завершение'}],
      block_charges: [],
      call_fields: [
        {key: 'number', label: 'Номер'}, {key: 'called', label: 'Набор'}, {key: 'country', label:'Страна'},
        {key: 'code_name', label:'Направление'}, {key: 'bdate', label:'Начало'},
        {key: 'call_duration', label: 'Секунд'},
        // {key: 'steps', label: 'Шаги'},
        {key: 'price', label:'Цена'},{key: 'final_amount', label: 'Начисление'}],
      receipt_fields: [
          {key: 'service_name', label: 'Услуга'},
          {key: 'final_amount', label: 'Начислено'}],
    }
  },
  computed: {
    ...mapGetters({
      accounts: 'listAccounts'
    }),
    valid_pass: function(){
      return this.new_password.length >= 6 ? false : true;
    },
    receipt_to_email: function (){
      if (this.current_account){
        return this.$store.state.accounts[this.current_account].receipt_to_email
      } else return false
    },
    account_email: function (){
      let email = ''
      if (this.current_account){
        if (this.$store.state.accounts[this.current_account].delivery_email !== ''){
          email = this.$store.state.accounts[this.current_account].delivery_email
        }
      }
      if (email === ''){
        if (this.$store.state.username.indexOf('@') > -1){
          email = this.$store.state.username
        } else {
          email = 'Введите email'
        }
      }
      return email
    },
  },
  // computed: {
  //
  //   account_list() {
  //     return this.$store.state.accounts
  //   },
  //   account_list_len() {
  //     // console.log('this.$store.state.accounts.length', this.$store.state.accounts.length)
  //     return this.$store.state.accounts.length
  //   }
  // },
  watch: {
  },
  mounted() {
    setTimeout(function(scope) {
      if (scope.$store.state.accounts.length === 0) {
        this.reloadAccounts()
      }
    }, 1000, this);
  },
  methods: {
    openInNewTab() {
      // localStorage.setItem('current_document_id', token)
      // this.$store.state.current_document = 'test'

      window.open('receipt/' + this.$store.state.current_document.id + '/', '_blank', 'noreferrer');
    },
    // accounts: function() {return Object.values(this.$store.state.accounts) },
    account_list_len: function() {
      return this.$store.state.accounts.length
    },
    refreshAccount: function(account_id) {
      this.$store.dispatch('getAccountApps', account_id)
    },
    reloadAccounts: function() {
      this.$store.dispatch('getAccounts')
    },
    app_charge: function (app){
      let total = 0.0
      if (app.services.length == 0) {return 0}
      if (app !== undefined){Object.values(app.services).forEach(element => total += parseFloat(element.charge))}
      return total
    },
    serviceTypeIconColor: function (app){
      if (!app.blocked){return 'primary'}
      else {
        if (app.block_code == 'INITIAL'){return 'success'}
        else if (app.block_code == 'VOLUNTARY'){return 'warning'}
        else {return 'danger'}}
    },
    traficRowClass: function(item, type) {
        if (!item || type !== 'row') return
        if (item.until === '') return 'table-success'
      },
    // plan switch control
    switchConfirm: function (tar_plan){
      this.switch_to_plan = tar_plan
      this.confirm_switch = true
    },
    showPlanChange: function (app, event){
      event.stopPropagation();
      this.selected_app = app
      // this.$store.dispatch('sendMessage', {'event': 'api/request', data: {'method': 'get_app_tar_plan_change_list', 'param': app_id}, 'topic': 'almaty'})
      this.$store.dispatch('getAppTarPlanChangeList', app.app_id)
      this.$bvModal.show('app-change-plan')
    },
    closePlanChange: function (){
      this.$bvModal.hide('app-change-plan')
      this.selected_app = null
    },
    closeConfirm: function (){
      this.switch_to_plan = null
      this.confirm_switch = false
    },
    serviceTypeIcon: function (service_type){
      if (service_type === 'PHONE'){return 'telephone'}
      else if (service_type === 'INTERNET'){return 'globe'}
      else if (service_type === 'PACKAGE'){return 'box-seam'}
      else if (service_type === 'TV'){return 'tv'}
      else if (service_type === 'RENT'){return 'hdd'}
      else {return 'question';}
    },
    changePlan: function (){
      this.selected_app.plan_change = false
      this.$store.dispatch('changeAppTarPlan', {"app_id": this.selected_app.app_id, "tar_plan_id": this.switch_to_plan.tar_plan_id})
      this.closePlanChange()
    },
    // plan switch control end
    // app block control
    showBlock: function (app, event){
      event.stopPropagation();
      this.$store.dispatch('getAppBlockTarifList', app.app_id)
      this.$bvModal.show('app-block')
      this.selected_app = app
    },
    hideBlock: function (){
      this.$bvModal.hide('app-block')
    },
    showUnblock: function (){
      this.$bvModal.show('app-unblock')
    },
    hideUnBlock: function (){
      this.$bvModal.hide('app-unblock')
    },
    appBlockConfirm: function (){
      this.selected_app.blockable = false
      this.$store.dispatch('blockApp', {"app_id": this.selected_app.app_id})
      this.hideBlock()
    },
    appUnBlockConfirm: function (){
      this.$store.dispatch('unblockApp', {"app_id": this.selected_app.app_id})
      this.hideUnBlock()
    },
    // app block control end
    // app inet traffic
    showInetTraffic: function (app, event){
      event.stopPropagation();
      this.$store.dispatch('getAppInetTraffic', app.app_id)
      this.$bvModal.show('app-inet-traffic')
      this.selected_app = app
    },
    hideInetTraffic: function (){
      this.$bvModal.hide('app-inet-traffic')
    },
    // app inet traffic end
    // app phone traffic
    showPhoneTraffic: function (app, event){
      event.stopPropagation();
      this.$store.dispatch('getAppCalls', app.app_id)
      this.$bvModal.show('app-phone-traffic')
      this.selected_app = app
    },
    hidePhoneTraffic: function (){
      this.$bvModal.hide('app-phone-traffic')
    },
    // app phone traffic end
    showAddAccount: function (){
      this.$bvModal.show('add-account')
    },
    hideAddAccount: function (){
      this.$bvModal.hide('add-account')
    },
    addAccount: function (){
      this.hideAddAccount();
      this.$store.dispatch('addAccount', this.form)
    },
    localiceSpeed: function (speed){
      return speed.replace('Mb/s', 'Мб/с')
    },
    showPassChange: function (app, event){
      event.stopPropagation();
      this.$bvModal.show('app-pass-change')
      this.selected_app = app
    },
    hidePassChange: function (){
      this.$bvModal.hide('app-pass-change')
    },
    appChangePass: function (){
      this.$store.dispatch('changeInetPass', {"app_id": this.selected_app.app_id, "new_password": this.new_password})
      this.$bvModal.hide('app-pass-change')
    },
    showAccountReceipt: function(account_id){
      this.$store.dispatch('getCurrentReceipt', {"account_id": account_id})
      this.$bvModal.show('account-receipt');
      this.current_account = account_id;
    },
    hideAccountReceipt: function(){this.$bvModal.hide('account-receipt')},
    setSendToEmail: function(checked){
      Vue.set(this.$store.state.accounts[this.current_account], 'receipt_to_email', checked)
      this.$store.dispatch('setSendReceiptToEmail', {"send": checked, "email": this.account_email, "account_id": this.current_account})
    },
    emailChange: function (value){
      this.change_email_enabled = value

    }
  },
}
</script>

<style scoped>

.actions-col {
    -ms-flex: 0 0 25px;
    flex: 0 0 25px;
    padding-left: 1px;
    padding-right: 1px;
    margin-right: 10px;
}

.balance-col {
    -ms-flex: 0 0 200px;
    flex: 0 0 200px;
    padding-left: 1px;
    padding-right: 1px;
}

.icon-service-type {
  margin-left: 5px !important;
}

.card {
  margin-bottom: 10px;
}

</style>